module.exports = {"name":"showApiErrors","audiences":["allMembers","alphaMembers"],"experimentAllocation":{"alphaMembers":1,"allMembers":0},"defaultWeight":1,"experimentVersion":"v1","defaults":{"enabled":false},"variations":[{"name":"enabled","weight":1,"values":{"enabled":true}}],"autoTrack":true}


//////////////////
// WEBPACK FOOTER
// ./app/common/lib/experiments/config/showApiErrors.json
// module id = qfIv
// module chunks = 13